// extracted by mini-css-extract-plugin
module.exports = {"root":"PaginaCard_root__Qpbno","title":"PaginaCard_title__XFO_B","rotation":"PaginaCard_rotation__8gOlc"};